import { AsyncPipe } from '@angular/common'
import { Component, inject } from '@angular/core'
import { PaginacaoLoadingService } from '@/app/core/service/paginacao-loading.service'

@Component({
  selector: 'app-paginacao-loading',
  standalone: true,
  imports: [AsyncPipe],
  template: `
    @if (loading.carregando$ | async) {
      <div class="paginacao-loading" role="status" aria-live="polite" aria-busy="true">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
        <span>Carregando...</span>
      </div>
    }
  `,
  styles: `
    .paginacao-loading {
      position: fixed;
      inset: 0;
      z-index: 10050;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      background-color: rgba(255, 255, 255, 0.75);
      color: #495057;
      font-size: 0.875rem;
      cursor: wait;
      user-select: none;
    }

    :host-context(html[data-bs-theme='dark']) .paginacao-loading {
      background-color: rgba(0, 0, 0, 0.65);
      color: #dee2e6;
    }
  `,
})
export class PaginacaoLoadingComponent {
  readonly loading = inject(PaginacaoLoadingService)
}
